import { Glyph } from "../lib/glyphs";
import { useReveal } from "../lib/useReveal";

interface Step {
  title: string;
  glyph: string;
  copy: string;
}

const STEPS: Step[] = [
  {
    title: "Discover",
    glyph: "search",
    copy: "Clarify the business goal, the constraints, the users, and the systems already in play.",
  },
  {
    title: "Design",
    glyph: "layers",
    copy: "Set the architecture, the delivery plan, the controls, and how success gets measured.",
  },
  {
    title: "Build",
    glyph: "code",
    copy: "Ship in reviewable increments with quality, security, and observability built in.",
  },
  {
    title: "Operate",
    glyph: "chart",
    copy: "Measure real usage, remove the friction it exposes, and keep the platform evolving.",
  },
];

export function DeliveryFlow(): React.ReactElement {
  const { ref, shown } = useReveal(0.3);

  return (
    <div ref={ref} className={`flow${shown ? " is-shown" : ""}`}>
      <div className="flow-track" aria-hidden="true">
        <span className="flow-track-fill" />
      </div>
      <ol className="flow-steps">
        {STEPS.map((step, index) => (
          <li
            key={step.title}
            className="flow-step"
            style={{ "--step-delay": `${index * 180}ms` } as React.CSSProperties}
          >
            <span className="flow-marker" aria-hidden="true">
              <svg viewBox="0 0 24 24" className="flow-marker-icon">
                <Glyph name={step.glyph} size={22} x={12} y={12} />
              </svg>
            </span>
            <div className="flow-body">
              <h3>{step.title}</h3>
              <p>{step.copy}</p>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}
